
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/futures/contract/[symbol]",
      function () {
        return require("private-next-pages/futures/contract/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/futures/contract/[symbol]"])
      });
    }
  